import React, { Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { withI18n } from "react-i18next";

import SuccessIcon from "../../images/cwb-check-circle-solid.svg";
import { RouteComponentProps } from "react-router-dom";

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t: any;
  delay: any;
}

interface IState {
  visible: boolean;
}

class Alert extends React.Component<IProps, IState> {
  _timer: any = null;

  public state: IState = {
    visible: true,
  };

  componentDidMount() {
    this.setTimer();
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.messages !== this.props.messages) {
      this.setTimer();
      this.setState({ visible: true });
    }
  }

  setTimer = () => {
    this._timer = clearTimeout(this._timer);

    this._timer = setTimeout(() => {
      this.setState({ visible: false });
      this.props.closeAlert(this.props.value);
      this._timer = null;
    }, 2000);
  };

  render() {
    const { value, index, t } = this.props;

    return (
      <Fragment>
        {this.state.visible ? (
          <StyledDiv
            className={`alert alert-dismissible fade show alert-${value.type}`}
            role={"alert" + index}
          >
            {value.type === "success" && <StyledImg src={SuccessIcon} alt="" />}
            {value.type === "error" && (
              <ErrorImg className="icon-cwb-plus-white" />
            )}
            <StyledText>{t(value.message)}</StyledText>
            <StyledButton
              type="button"
              className="close"
              data-dismiss={"alert" + index}
              aria-label="Close"
            >
              <div
                data-cy="alert-close"
                aria-hidden="true"
                onClick={() => this.props.closeAlert(value)}
              >
                &times;
              </div>
            </StyledButton>
          </StyledDiv>
        ) : (
          ""
        )}
      </Fragment>
    );
  }
}

interface StateProps {
  messages: any;
  value: any;
  index: number;
}

function mapStateToProps(state: any, ownProps: any): StateProps {
  return {
    messages: state.alert.messages,
    value: ownProps.value,
    index: ownProps.index,
  };
}

interface DispatchProps {
  closeAlert: (value: any) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    closeAlert: dispatch.alert.closeAlert,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(Alert));

const StyledDiv = styled.div`
  min-height: 48px;
  height: auto;
  width: 368px;
  max-width: 368px;
  display: flex;
  align-items: center;
  box-shadow: 0 0 1px 0 rgba(10, 31, 68, 0.1),
    0 10px 18px 0 rgba(10, 31, 68, 0.12);
  transition: all 0.3s ease-in-out;
  &.alert-success {
    background-color: #0bb07b;
  }
  &.alert-error {
    background-color: #ff1870;
  }
`;

const StyledImg = styled.img`
  width: 16px !important;
  min-height: 16px;
  height: auto;
`;

const StyledText = styled.span`
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-left: 12px;
`;

const StyledButton = styled.button`
  padding: 0 !important;
  top: unset !important;
  right: 12px !important;
  outline: 0 !important;
  color: #ffffff !important;
  font-size: 20px !important;
  font-weight: normal !important;
  &&&,
  &:hover {
    opacity: 1 !important;
  }
`;

const ErrorImg = styled.i`
  background: white;
  border-radius: 25px;
  padding: 3px;
  transform: rotate(45deg);
  font-size: 10px;
  font-weight: 800;
  &:before {
    color: #ff1870 !important;
  }
`;
